export default __webpack_public_path__ + "static/media/dm.726ddd1d.svg";